var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.11,-1.17969 H -1.11328 V 4253.18 H 4253.11 V -1.17969",
    style: {
      fill: "#8d1231",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 679.16,3233.57 c 0,-51.89 -18.972,-88.57 -70.812,-88.57 -50.657,0 -69.606,36.68 -69.606,88.57 v 139.18 c 0,51.84 18.949,88.56 69.606,88.56 51.84,0 70.812,-36.72 70.812,-88.56 z m -135.379,474.39 c 0,51.95 17.758,82.31 64.567,82.31 48.015,0 65.781,-30.36 65.781,-82.31 v -58.14 c 0,-51.87 -17.766,-82.3 -65.781,-82.3 -46.809,0 -64.567,30.43 -64.567,82.3 z m 279.617,-459.21 v 93.64 c 0,82.2 -29.066,141.69 -96.136,172.07 56.875,27.78 83.492,78.39 83.492,149.25 v 35.47 c 0,134.1 -69.574,206.21 -202.406,206.21 -131.567,0 -199.93,-72.11 -199.93,-206.21 v -35.47 c 0,-69.6 25.352,-121.47 80.965,-149.25 -67.047,-30.38 -94.906,-89.87 -94.906,-172.07 v -93.64 c 0,-130.29 62.039,-221.4 213.871,-221.4 153.039,0 215.05,91.11 215.05,221.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1277.59,3769.56 H 1276 l -40.8,-233.17 h -28.08 l -45.05,233.17 h -1.06 v -233.17 h -49.81 v 359.29 h 70.48 l 39.21,-202.43 h 0.53 l 34.98,202.43 h 76.31 v -359.29 h -55.12 v 233.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1359.22,3895.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.89 v -48.75 h -59.89 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1578.64,3762.14 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1725.98,3613.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.07,0 27.56,12.72 27.56,31.8 v 13.78 c 0,20.66 -8.49,33.38 -27.03,50.87 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.16 h -55.11 v 31.27 c 0,20.67 -9.55,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.68,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.26 v -17.49 c 0,-49.28 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1923.14,3629.13 v 173.82 c 0,56.17 26.49,96.97 90.09,96.97 66.78,0 85.32,-37.09 85.32,-90.08 v -42.4 h -55.12 v 47.17 c 0,22.25 -7.42,34.97 -29.14,34.97 -21.73,0 -30.74,-15.37 -30.74,-37.1 v -192.89 c 0,-21.73 9.01,-37.1 30.74,-37.1 21.72,0 29.14,13.78 29.14,34.97 v 66.25 h 55.12 v -62 c 0,-51.41 -21.2,-89.56 -85.32,-89.56 -63.6,0 -90.09,41.33 -90.09,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2242.18,3694.84 h -58.29 v -158.45 h -60.42 v 359.29 h 60.42 v -152.09 h 58.29 v 152.09 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2329.64,3895.68 h 144.15 v -49.28 h -83.74 v -102.81 h 59.89 v -48.75 h -59.89 v -109.17 h 83.74 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2549.05,3762.14 v -225.75 h -50.87 v 359.29 h 59.36 l 65.17,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2829.94,3758.43 -33.92,-222.04 h -56.7 l -48.22,359.29 h 58.29 l 28.09,-227.87 h 0.52 l 30.21,227.87 h 49.29 l 33.38,-227.87 h 0.53 l 27.56,227.87 h 50.87 l -46.63,-359.29 h -57.24 l -35.51,222.04 h -0.52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3083.28,3953.98 h 51.4 v -45.58 h -51.4 z m -64.12,0 h 51.4 v -45.58 h -51.4 z m 144.14,-58.3 v -271.85 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.85 h 60.42 V 3618 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.2,0 29.67,14.31 29.67,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3250.23,3846.4 v -111.81 h 20.14 c 20.67,0 29.67,10.59 29.67,29.67 v 53 c 0,19.6 -9,29.14 -29.67,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.75,-163.22 h -63.58 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3471.76,3585.67 c 24.92,0 34.46,14.84 34.46,36.56 v 188.14 c 0,21.19 -9.54,36.03 -34.46,36.03 h -25.43 v -260.73 z m 94.87,213.57 v -166.4 c 0,-55.12 -22.79,-96.45 -87.44,-96.45 h -93.28 v 359.29 h 93.28 c 64.65,0 87.44,-40.8 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3593.14,3895.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3771.74,3728.22 h 85.85 v -191.83 h -43.45 v 39.21 c -7.95,-27.03 -24.92,-43.45 -57.77,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.82 c 0,56.17 27.02,96.97 90.62,96.97 66.77,0 86.38,-37.09 86.38,-90.08 v -31.8 h -55.11 v 36.57 c 0,22.25 -8.48,34.97 -30.21,34.97 -21.73,0 -31.27,-15.37 -31.27,-37.1 v -192.89 c 0,-21.73 9.02,-37.1 29.68,-37.1 19.61,0 29.68,11.13 29.68,34.45 v 63.59 h -28.62 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3884.11,3895.68 h 144.14 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1177.44,3150.32 h 48.22 l -23.85,144.15 h -0.52 z m -75.78,-113.93 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1384.14,3346.4 v -111.82 h 20.13 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.94,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1580.23,3198.02 v -112.35 h 26.49 c 20.15,0 29.68,10.07 29.68,29.15 v 54.05 c 0,19.08 -9,29.15 -30.2,29.15 z m 0,46.1 h 21.2 c 19.61,0 28.61,10.07 28.61,29.15 v 43.99 c 0,19.6 -9,29.14 -29.14,29.14 h -20.67 z m -60.41,151.56 h 87.44 c 60.41,0 80.55,-28.08 80.55,-78.96 v -36.56 c 0,-30.21 -11.12,-49.29 -36.04,-57.24 30.21,-6.88 45.05,-27.02 45.05,-59.88 v -47.69 c 0,-50.88 -22.79,-78.96 -83.2,-78.96 h -93.8 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1719.1,3395.68 h 144.14 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 H 1719.1 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1887.63,3395.68 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1968.19,3395.68 h 160.57 v -49.28 h -49.82 V 3036.39 H 2018 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2372.02,3395.68 v -271.85 c 0,-55.65 -23.85,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 V 3118 c 0,-21.2 8.47,-35.51 29.68,-35.51 21.19,0 29.66,14.31 29.66,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2449.41,3262.14 v -225.75 h -50.87 v 359.29 h 59.36 l 65.17,-206.14 v 206.14 h 50.35 v -359.29 h -52.99 l -71.02,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2685.79,3085.67 c 24.9,0 34.44,14.84 34.44,36.57 v 188.13 c 0,21.19 -9.54,36.03 -34.44,36.03 h -25.44 v -260.73 z m 94.85,213.57 v -166.4 c 0,-55.12 -22.78,-96.45 -87.43,-96.45 h -93.27 v 359.29 h 93.27 c 64.65,0 87.43,-40.8 87.43,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1241.56,2758.43 -33.92,-222.04 h -56.7 l -48.22,359.29 h 58.29 l 28.09,-227.87 h 0.53 l 30.2,227.87 h 49.29 l 33.39,-227.87 h 0.52 l 27.56,227.87 h 50.87 l -46.63,-359.29 h -57.24 l -35.5,222.04 h -0.53",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1399.51,2895.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1547.37,2846.4 v -111.82 h 20.14 c 20.67,0 29.67,10.6 29.67,29.68 v 53 c 0,19.6 -9,29.14 -29.67,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.94,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.75,-163.22 h -63.58 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1670.87,2895.68 h 160.57 v -49.28 h -49.81 v -310.01 h -60.95 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1843.11,2613.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.02,-31.8 29.68,-31.8 19.08,0 27.56,12.72 27.56,31.8 v 13.77 c 0,20.67 -8.48,33.39 -27.02,50.88 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.97,78.96 84.78,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.15 h -55.11 v 31.26 c 0,20.67 -9.54,30.74 -28.62,30.74 -16.95,0 -28.61,-9.54 -28.61,-29.68 v -7.42 c 0,-20.13 11.13,-31.79 28.61,-48.75 l 38.69,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.49,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2040.27,2629.13 v 173.81 c 0,56.18 26.5,96.98 90.1,96.98 66.76,0 85.31,-37.09 85.31,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.26 -7.42,34.98 -29.15,34.98 -21.73,0 -30.73,-15.37 -30.73,-37.09 v -192.91 c 0,-21.72 9,-37.09 30.73,-37.09 21.73,0 29.15,13.78 29.15,34.98 v 66.24 h 55.11 v -62 c 0,-51.41 -21.19,-89.56 -85.31,-89.56 -63.6,0 -90.1,41.33 -90.1,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2359.31,2694.84 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.09 h 58.29 v 152.09 h 60.95 v -359.29 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2513.02,2650.32 h 48.23 l -23.85,144.15 h -0.53 z m -75.78,-113.93 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.12,65.71 h -64.13 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2659.3,2895.68 h 141.5 v -49.28 h -81.09 v -102.81 h 60.41 v -48.75 h -60.41 v -158.45 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2815.11,2895.68 h 160.57 v -49.28 h -49.81 v -310.01 h -60.94 v 310.01 h -49.82 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2987.36,2613.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.07,0 27.56,12.72 27.56,31.8 v 13.77 c 0,20.67 -8.49,33.39 -27.03,50.88 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.96,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.15 h -55.12 v 31.26 c 0,20.67 -9.54,30.74 -28.61,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.13 11.13,-31.79 28.62,-48.75 l 38.68,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3170.21,2748.89 h 84.8 v -48.75 h -84.8 v 48.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1241.56,2258.43 -33.92,-222.04 h -56.7 l -48.22,359.29 h 58.29 l 28.09,-227.87 h 0.53 l 30.2,227.87 h 49.29 l 33.39,-227.87 h 0.52 l 27.56,227.87 h 50.87 l -46.63,-359.29 h -57.24 l -35.5,222.04 h -0.53",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1444.56,2150.32 h 48.22 l -23.85,144.15 h -0.53 z m -75.78,-113.93 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1582.89,2129.13 v 173.81 c 0,56.18 26.5,96.98 90.09,96.98 66.77,0 85.32,-37.09 85.32,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.26 -7.42,34.98 -29.15,34.98 -21.73,0 -30.73,-15.37 -30.73,-37.09 v -192.91 c 0,-21.72 9,-37.09 30.73,-37.09 21.73,0 29.15,13.78 29.15,34.98 v 66.24 h 55.11 v -62 c 0,-51.41 -21.19,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.33 -90.09,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1901.93,2194.84 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.09 h 58.29 v 152.09 h 60.95 v -359.29 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1986.22,2113.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9,-31.8 29.68,-31.8 19.07,0 27.55,12.72 27.55,31.8 v 13.77 c 0,20.67 -8.48,33.39 -27.03,50.88 l -35.5,35.51 c -34.45,33.91 -50.35,54.58 -50.35,95.91 v 12.19 c 0,44.52 25.97,78.96 84.8,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.15 h -55.12 v 31.26 c 0,20.67 -9.54,30.74 -28.61,30.74 -16.97,0 -28.63,-9.54 -28.63,-29.68 v -7.42 c 0,-20.13 11.14,-31.79 28.63,-48.75 l 38.68,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.26 v -17.49 c 0,-49.29 -26.51,-84.26 -87.97,-84.26 -61.48,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2168.53,2395.68 h 160.58 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.82 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2524.66,2395.68 v -271.85 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.59,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 V 2118 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2717.58,2269.56 h -1.59 l -40.8,-233.17 h -28.08 l -45.05,233.17 H 2601 v -233.17 h -49.81 v 359.29 h 70.48 l 39.21,-202.43 h 0.53 l 34.98,202.43 h 76.31 v -359.29 h -55.12 v 233.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2673.4,1506.58 -286.55,-272.6 c -10.82,-10.76 -16.36,-18.68 -16.36,-40.94 V 429.031 c 0,-8.972 7.33,-16.312 16.36,-16.312 h 296.01 c 9.01,0 16.3,7.34 16.3,16.312 V 1499.7 c 0,9.02 -7.05,25.48 -25.76,6.88",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1847.86,1151.43 1561.27,878.859 c -10.79,-10.777 -16.35,-18.679 -16.35,-40.91 V 429.031 c 0,-8.929 7.35,-16.281 16.35,-16.281 h 296.02 c 9.03,0 16.32,7.352 16.32,16.281 v 715.559 c 0,9.03 -7.12,25.52 -25.75,6.84",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2803.66,1837.16 c 0.11,2.18 -0.67,4.5 -2.43,6.21 -1.51,1.47 -3.44,2.16 -5.31,2.33 l -1.57,-0.1 -2.34,-0.14 -219.43,-49.5 -3.98,-0.41 c -1.57,-0.31 -3.07,-1.09 -4.28,-2.24 -3.23,-3.27 -3.23,-8.54 0,-11.81 l 2.48,-2.48 50.11,-50.09 -497.2,-497.21 -229.64,229.66 c -2.6,2.61 -6.73,2.61 -9.35,0 l -62.31,-62.33 c -0.04,0 -0.04,-0.07 -0.04,-0.07 l -368.13,-368.05 c -2.55,-2.6 -2.55,-6.81 0,-9.36 l 62.4,-62.371 c 2.55,-2.578 6.71,-2.578 9.27,0 L 1885.45,1322.66 2052.09,1156 c 0.17,-0.26 0.25,-0.54 0.53,-0.79 l 62.33,-62.26 c 2.59,-2.62 6.74,-2.62 9.34,0 l 564.3,564.29 52.63,-52.59 c 3.23,-3.27 8.49,-3.27 11.7,0 1.54,1.54 2.29,3.42 2.39,5.4 l 0.04,0.71 48.19,223.99 0.12,2.41",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2262.26,1103.59 2123.61,963.789 c -2.64,-2.168 -6.49,-2.109 -8.94,0.34 l -125.61,128.051 c -22.99,22.91 -27.96,4.33 -27.96,-4.67 V 429.059 c 0,-8.957 7.23,-16.309 16.23,-16.309 h 296.08 c 8.97,0 16.29,7.352 16.29,16.309 v 669.361 c 0,9 -7.1,25.53 -27.44,5.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe08);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-08.1a76693d9605ffc60d869cef2392a4f0.svg";
export { ForwardRef as ReactComponent };